(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        
        vm.setActive = setActive;
        vm.load($stateParams.id);

        function load (id) {
            User.get({id: id}, function(result) {
                vm.user = result;
            });
        }
        
        
        function setActive (user, isActivated) {
            user.activated = isActivated;
            user.activeFromDate = null;
            user.activeToDate= null;
            User.update(user, function (user) {
                vm.user = user;
            });
        }
    }
    
    
})();
